
import Peripherals from '@appblocks/codegeneration/Peripherals';

export default {
    getGPIOPhandleArrayCode(feature: any, settingId: string, project: any): string {
        let pins = feature.getSettingValue(settingId);
        let code = '';
        if (typeof pins === 'string') {
            pins = [pins];
        }
        if (pins !== undefined && pins.length > 0) {
            const items: string[] = [];
            for (let i = 0; i < pins.length; i++) {
                const GPIOPIN = project.getFeature(pins[i]);
                const pin = Peripherals.getGPIOPeripheral(GPIOPIN.getSettingValue('PIN'), project.device.id);
                items.push(`<&${pin?.peripheralPort} ${pin.num} ${GPIOPIN.getFlags()}>`);
            }
            code = items.join(', ');
        }
        return code;
    },

    getGPIOCode(gpioFeatureId: string, project: any): string {
        let code = '';
        const gpioFeature = project.getFeature(gpioFeatureId);
        if (gpioFeature) {
            const GPIO = Peripherals.getGPIOPeripheral(gpioFeature.getSettingValue('PIN'), project.device.id);
            code = `<&${GPIO.peripheralPort} ${GPIO.num} ${gpioFeature.getFlags()}>`;
        }
        return code;
    },

    getFlags(feature: any): string {
        const flags = [];
        const PULL = feature.getSettingValue('PULL');
        const DRIVE = feature.getSettingValue('DRIVE');
        const ACTIVE = feature.getSettingValue('ACTIVE');

        if (PULL !== '') {
            flags.push(`GPIO_PULL_${PULL.toUpperCase()}`);
        }
        if (DRIVE !== '' && DRIVE !== undefined) {
            flags.push(`GPIO_${DRIVE === '1' ? 'OPEN_DRAIN' : 'OPEN_SOURCE'}`);
        }

        if (ACTIVE !== '') {
            flags.push(`GPIO_ACTIVE_${ACTIVE === '1' ? 'HIGH' : 'LOW'}`);
        }
        if (flags.length === 0) {
            return '';
        }

        return `(${flags.join(' | ')})`;
    },
};
